import React from "react"
import PropTypes from "prop-types"
import { Link, BrowserRouter as Router } from "react-router-dom"
import cx from "classnames"

// Utils
import { getColor, getCircleDiameter, getPersonDepartmentName } from "../utils"

const TableRow = props => {
  const { rowData, keys, rowSpacing, childLevel } = props
  const { id, name, employeeFirst, employeeLast } = rowData

  if (Object.keys(rowData).length) {
    const getScores = key => {
      const score = rowData.scores.filter(obj => {
        return obj.key === key
      })
      return score[0].scores.score
    }

    return (
      <div className="d-flex align-items-center" key={`tr-${id}`}>
        {keys.map(key =>
          key === "name" ? (
            <div
              key={`${key}-${id}`}
              style={rowSpacing}
              className="text-align-left text-truncate circles-tr pt-1"
            >
              <Router>
                <Link
                  to={`/engagement/vision2/insights/${childLevel}/${id}`}
                  className={cx("min-width-0 text-truncate mb-0", {
                    "demo-tour-step-6": name === "Human Resources"
                  })}
                >
                  {getPersonDepartmentName(name, employeeFirst, employeeLast)}
                </Link>
              </Router>
            </div>
          ) : (
            <div
              key={`${key}-${id}`}
              style={rowSpacing}
              className="text-align-center d-flex flex-column flex-wrap circles-tr justify-content-center align-items-center"
            >
              <div
                style={{
                  borderRadius: "50%",
                  width: getCircleDiameter(getScores(key)),
                  height: getCircleDiameter(getScores(key)),
                  backgroundColor: getColor(getScores(key))
                }}
              />
            </div>
          )
        )}
      </div>
    )
  }
  return null
}

export default TableRow

TableRow.propTypes = {
  rowData: PropTypes.shape({
    id: PropTypes.any,
    name: PropTypes.string,
    employeeFirst: PropTypes.string,
    employeeLast: PropTypes.string,
    is_manager: PropTypes.bool,
    scores: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        scores: PropTypes.shape({
          score: PropTypes.number
        })
      })
    )
  }).isRequired,
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  rowSpacing: PropTypes.shape({
    flex: PropTypes.string,
    minWidth: PropTypes.string
  }).isRequired,
  childLevel: PropTypes.string.isRequired
}
